import { authFetch } from 'shared/api/authFetch';
import { config } from 'shared/config/config';

const readResponse = async (response) => {
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload?.detail || 'Credential setup request failed');
  }
  return payload;
};

export const fetchCredentialRequest = async ({ requestId, orgId }) => {
  const response = await authFetch(
    `${config.API_URL}/api/integrations/credential-requests/${encodeURIComponent(
      requestId
    )}?orgId=${encodeURIComponent(orgId)}`
  );
  return readResponse(response);
};

export const completeCredentialRequest = async ({ requestId, orgId, values }) => {
  const response = await authFetch(
    `${config.API_URL}/api/integrations/credential-requests/${encodeURIComponent(
      requestId
    )}/complete?orgId=${encodeURIComponent(orgId)}`,
    {
      method: 'POST',
      body: JSON.stringify({ values }),
    }
  );
  return readResponse(response);
};

